<template>
  <main class="main profile-page page-inside" v-if="isAuth">
    <div class="main-wrapper">
      <div class="section hero-section"></div>
      <div class="section profile-section">
        <div class="wrapper">
          <div class="profile-form">
            <div class="profile-form-wrapper">
              <div class="wrapper">
                <div class="profile-top-container">
                  <div class="profile-top">
                    <div class="profile-top-left">
                      <div class="text">
                        <div class="title extrasmall">{{ name }} {{ surname }}</div>
                        <!-- <div class="desc">
                          <b>{{ $t(`Joined:`) }}</b>
                          {{ $parent.formatDate(joined) }}
                        </div> -->
                      </div>
                    </div>
                    <div class="profile-top-right">
                      <img src="./../img/walletProfile.svg" class="img" />
                      <div class="text">
                        <div class="desc semibold">
                          <span
                            >{{ balance }}
                            {{ internalCurrencyName }}</span
                          >
                        </div>
                      </div>
                      <button
                        class="button"
                        @click="openTopUpModal(0.0)"
                      >
                        <img src="./../img/plus-sign.svg" class="img" />
                      </button>
                    </div>
                  </div>
                  <div class="profile-nav-container">
                    <ul class="profile-nav pack-list">
                      <template :key="i" v-for="(item, i) in profileNav">
                        <li
                          :class="[
                            'pack-list__item',
                            { active: item.page === activeProfilePage },
                          ]"
                          @click="goToProfilePage(item.page)"
                        >
                          <div class="desc">{{ item.title }}</div>
                        </li>
                      </template>
                    </ul>
                    <li class="pack-list__item" @click="logout">
                      <div class="desc">{{ $t(`Log out`) }}</div>
                    </li>
                  </div>
                </div>

                <div
                  class="content personal-info"
                  v-if="activeProfilePage === 'contact-info'"
                >
                  <div class="block">
                    <div class="block-top">
                      <div class="title small">
                        {{ $t(`Contact Information`) }}
                      </div>
                      <div class="fields">
                        <div class="input-container">
                          <div class="desc">
                            <span class="red">*</span> {{ $t("First name") }}:
                          </div>
                          <input
                            type="text"
                            :placeholder="$t('First name')"
                            v-model="name"
                          />
                          <transition name="fade">
                            <div
                              v-if="errors.name && errors.name.length"
                              class="error-message"
                            >
                              {{ errors.name[0] }}
                            </div>
                          </transition>
                        </div>
                        <div class="input-container">
                          <div class="desc">
                            <span class="red">*</span> {{ $t("E-mail") }}:
                          </div>
                          <input
                            type="email"
                            :placeholder="$t('E-mail')"
                            v-model="email"
                          />
                          <transition name="fade">
                            <div
                              v-if="errors.email && errors.email.length"
                              class="error-message"
                            >
                              {{ errors.email[0] }}
                            </div>
                          </transition>
                        </div>
                        <div class="input-container">
                          <div class="desc">
                            <span class="red">*</span> {{ $t("Last name") }}:
                          </div>
                          <input
                            type="text"
                            :placeholder="$t('Last name')"
                            v-model="surname"
                          />
                          <transition name="fade">
                            <div
                              v-if="errors.surname && errors.surname.length"
                              class="error-message"
                            >
                              {{ errors.surname[0] }}
                            </div>
                          </transition>
                        </div>
                        <div
                          class="input-container"
                          v-if="countryOptionsIso && countryOptionsIso.length"
                        >
                          <div class="desc">
                            <span class="red">*</span> {{ $t("Phone") }}:
                          </div>
                          <VuePhoneNumberInput
                              required
                              v-model="phone"
                              :only-countries="countryOptionsIso"
                              :default-country-code="getDefaultCountryIso"
                              @update="phoneDataUpdate($event)"
                              :translations="phoneInputTranslations"
                          />
                          <transition name="fade">
                            <div
                              v-if="errors.phone && errors.phone.length"
                              class="error-message"
                            >
                              {{ errors.phone[0] }}
                            </div>
                          </transition>
                        </div>
                      </div>
                    </div>
                    <button class="button" @click="updateProfileData">
                      <span>{{ $t(`Save`) }}</span>
                    </button>
                    <transition name="fade">
                      <div class="desc red" v-if="profileUpdateErrorMessaage">
                        {{ profileUpdateErrorMessaage }}
                      </div>
                    </transition>
                    <transition name="fade">
                      <div
                        class="desc green"
                        v-if="profileUpdateSuccessMessaage"
                      >
                        {{ profileUpdateSuccessMessaage }}
                      </div>
                    </transition>
                  </div>

                  <div class="block">
                    <div class="block-top">
                      <div class="title small">
                        {{ $t(`Address Information`) }}
                      </div>
                      <div class="fields">
                        <div class="input-container">
                          <div class="desc">
                            <span class="red">*</span> {{ $t("Address") }}:
                          </div>
                          <input
                            type="text"
                            :placeholder="$t('Address')"
                            v-model="address"
                          />
                          <transition name="fade">
                            <div
                              v-if="errors.address && errors.address.length"
                              class="error-message"
                            >
                              {{ errors.address[0] }}
                            </div>
                          </transition>
                        </div>

                        <div class="input-container">
                          <div class="desc">
                            <span class="red">*</span> {{ $t("City") }}:
                          </div>
                          <input
                            type="text"
                            :placeholder="$t('City')"
                            v-model="city"
                          />
                          <transition name="fade">
                            <div
                              v-if="errors.city && errors.city.length"
                              class="error-message"
                            >
                              {{ errors.city[0] }}
                            </div>
                          </transition>
                        </div>

                        <div class="input-container">
                          <div class="desc">
                            <span class="red">*</span> {{ $t("Post Code") }}:
                          </div>
                          <input
                            type="text"
                            :placeholder="$t('Post Code')"
                            v-model="postCode"
                          />
                          <transition name="fade">
                            <div
                              v-if="errors.post_code && errors.post_code.length"
                              class="error-message"
                            >
                              {{ errors.post_code[0] }}
                            </div>
                          </transition>
                        </div>

                        <div class="input-container">
                          <div class="desc">
                            <span class="red">*</span> {{ $t("Country") }}:
                          </div>
                          <select
                            v-model="country"
                            :class="{
                              'select-placeholder-text':
                                country == '' || country == null,
                            }"
                          >
                            <option selected value="">
                              {{ $t(`Country`) }}
                            </option>
                            <option
                              v-for="item in countryOptions"
                              :value="item"
                              :key="item.iso"
                            >
                              {{ item.name }}
                            </option>
                          </select>
                          <transition name="fade">
                            <div
                              v-if="errors.country && errors.country.length"
                              class="error-message"
                            >
                              {{ errors.country[0] }}
                            </div>
                          </transition>
                        </div>
                      </div>
                    </div>
                    <button class="button" @click="updateProfileData">
                      <span>{{ $t(`Save`) }}</span>
                    </button>
                  </div>

                  <div class="block">
                    <div class="block-top">
                      <div class="title small">{{ $t(`Change Password`) }}</div>
                      <div class="fields">
                        <div class="input-container">
                          <div class="desc">
                            <span class="red">*</span>
                            {{ $t("Current password") }}:
                          </div>
                          <input
                            type="password"
                            :placeholder="$t('Current password')"
                            v-model="curPass"
                          />
                        </div>
                        <div class="input-container long">
                          <div class="desc">
                            <span class="red">*</span> {{ $t("New password") }}:
                          </div>
                          <input
                            type="password"
                            :placeholder="$t('New password')"
                            v-model="newPass"
                          />
                        </div>
                        <div class="input-container long">
                          <div class="desc">
                            <span class="red">*</span>
                            {{ $t("Confirm password") }}:
                          </div>
                          <input
                            type="password"
                            :placeholder="$t('Confirm password')"
                            v-model="repeatPass"
                          />
                        </div>
                        <div class="pass-rules">
                          <div class="desc bold">
                            {{ $t("Password must contain:") }}
                          </div>
                          <div class="desc">
                            {{
                              $t(`At least 6 characters, 1 upper case letter (A-Z), 1 lower case letter
                            (a-z), 1 number (0-9)`)
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <button class="button" @click="updatePassword">
                      <span>{{ $t(`UPDATE`) }}</span>
                    </button>
                    <transition name="fade">
                      <div class="desc red" v-if="passUpdateErrorMessaage">
                        {{ passUpdateErrorMessaage }}
                      </div>
                    </transition>
                    <transition name="fade">
                      <div class="desc green" v-if="passUpdateSuccessMessaage">
                        {{ passUpdateSuccessMessaage }}
                      </div>
                    </transition>
                  </div>

                  <div class="block">
                    <div class="block-top">
                      <div class="title small">{{ $t(`Referral code`) }}</div>
                      <div class="fields">
                        <div class="input-container">
                          <div class="desc">
                            <span class="red">*</span>
                            {{ $t("Referral code") }}:
                          </div>
                          <input
                            type="text"
                            :placeholder="$t('Referral code')"
                            v-model="referralCode"
                          />
                        </div>
                      </div>
                    </div>
                    <button class="button" @click="updateReferralCode">
                      <span>{{ $t(`UPDATE`) }}</span>
                    </button>
                  </div>
                </div>
                <div
                  class="content profile-table"
                  v-if="activeProfilePage === 'promt-history'"
                >
                  <div class="profile-table-wrapper profile-form-wrapper">
                    <div class="title small">{{ $t(`My IdeasGen`) }}</div>
                    <div class="table-container">
                      <table>
                        <thead>
                          <tr>
                            <td>{{ $t(`Title`) }}</td>
                            <td class="prompt-col">{{ $t(`Prompt`) }}</td>
                            <td class="actions-col">{{ $t(`Actions`) }}</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, i) in promtHistory"
                            :key="i"
                          >
                            <td>{{ item.title }}</td>
                            <td>
                              <div class="prompt-text line-clamp" v-html="item.prompt"></div>
                            </td>
                            <td>
                              <div class="prompt-actions-cell">
                                <button class="action-btn-small" @click="copyPrompt(item.prompt)" :title="$t('Copy')">
                                  <span>{{ $t('Copy') }}</span>
                                </button>
                                <button class="action-btn-small" @click="downloadPrompt(item)" :title="$t('Download')">
                                  <span>{{ $t('Download') }}</span>
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div
                  class="content profile-table"
                  v-if="activeProfilePage === 'order-history'"
                >
                  <div class="profile-table-wrapper profile-form-wrapper">
                    <div class="title small">{{ $t(`Order history`) }}</div>
                    <div class="table-container">
                      <table>
                        <thead>
                          <tr>
                            <td>{{ $t(`Date/time`) }}</td>
                            <td>{{ $t(`Title`) }}</td>
                            <td>{{ $t(`Status`) }}</td>
                            <td>{{ $t(`Total`) }}</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, i) in orderHistory"
                            :key="i"
                          >
                            <td>{{ formatDate(item.created_at) }}</td>
                            <td>{{ item.title }}</td>
                            <td>
                              <div
                                :class="[
                                  'status',
                                  {
                                    green:
                                      item.status.toLowerCase() === 'success',
                                  },
                                ]"
                              >
                                {{ item.status }}
                              </div>
                            </td>
                            <td>
                              <b>{{ item.sum }}&nbsp;{{ item.currency }}</b>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div
                  class="content profile-table"
                  v-if="activeProfilePage === 'deposit-history'"
                >
                  <div class="profile-table-wrapper profile-form-wrapper">
                    <div class="title small">{{ $t(`Deposit history`) }}</div>
                    <div class="table-container">
                      <table>
                        <thead>
                          <tr>
                            <td>{{ $t(`Date/time`) }}</td>
                            <td>{{ $t(`Status`) }}</td>
                            <td>{{ $t(`Total`) }}</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, i) in depositHistory"
                            :key="i"
                          >
                            <td>{{ formatDate(item.created_at) }}</td>
                            <td>
                              <div
                                :class="[
                                  'status',
                                  {
                                    green:
                                      item.status.toLowerCase() === 'success',
                                  },
                                ]"
                              >
                                {{ item.status }}
                              </div>
                            </td>
                            <td>
                              <b>{{ item.sum }}&nbsp;{{ item.currency }}</b>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ConfirmationModal
      :visible="showDisclaimer"
      :title="$t('Warning')"
      :message="disclaimerMessage"
      :confirmText="$t('Proceed')"
      :cancelText="$t('Cancel')"
      @confirm="confirmReferralCodeUpdate"
      @close="cancelReferralCodeUpdate"
    />
  </main>
</template>
<script>
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'
import { useToast } from 'vue-toastification'
import ConfirmationModal from '../components/ConfirmationModal.vue'
import VuePhoneNumberInput from 'maz-ui/components/MazPhoneNumberInput'
import {filterPhoneCountries} from '@/utils/filterPhoneCountries'

export default defineComponent({
  name: 'Profile',
  props: ['currency'],
  inject: [
    'openSignInModal',
    'orderHistory',
    'promtHistory',
    'depositHistory',
    'formatDate',
    'logout',
    'openTopUpModal',
    'internalCurrencyName',
  ],
  components: {
    ConfirmationModal,
    VuePhoneNumberInput
  },

  data() {
    return {
      email: '',
      name: '',
      surname: '',
      phone: '',
      joined: '',
      balance: '',
      profileUpdateSuccessMessaage: '',
      profileUpdateErrorMessaage: '',
      curPass: '',
      newPass: '',
      repeatPass: '',
      passUpdateSuccessMessaage: '',
      passUpdateErrorMessaage: '',
      activeProfilePage: '',
      profileNav: [
        { page: 'contact-info', title: 'Profile' },
        { page: 'promt-history', title: 'My prompts' },
        { page: 'deposit-history', title: 'Deposit history' },
        { page: 'order-history', title: 'Order history' },
      ],
      phoneFull: '',
      countryOptions: [],
      countryOptionsIso: [],
      userCountryId: '',

      country: '',
      city: '',
      address: '',
      postCode: '',
      errors: {},

      referralCode: '',
      showDisclaimer: false,
      disclaimerMessage: '',
      currentDiscount: 0,
      newDiscount: 0,

      phoneInputTranslations: {
        countrySelector: {
          placeholder: 'Country code',
          error: 'Choose country',
          searchPlaceholder: 'Search a country',
        },
        phoneInput: {
          placeholder: '* Phone number',
          example: 'Example:',
        },
      }
    }
  },

  watch: {
    currency() {
      this.getProfile()
    },
    promtHistory: {
      handler(newVal) {
        if (newVal && newVal.length) {
          console.log('Prompts loaded:', newVal);
        }
      },
      immediate: true
    }
  },

  created() {
  },

  mounted() {
    this.activeProfilePage = this.$route.params.page
    Promise.all([this.getProfile(), this.getCountries()])
        .then(() => {
          this.setDefaultCountry()
        })
        .catch((err) => {
          if (err.response && err.response.status === 401) {
            this.openSignInModal()
          } else {
            console.error(err)
          }
        })
  },

  methods: {
    getCountries() {
      this.$http.get('countries')
          .then(res => {
            const allCountries = res.data.payload

            // Полный список для селекта
            this.countryOptions = allCountries

            // Отфильтрованные ISO коды только для phone input
            this.countryOptionsIso = filterPhoneCountries(allCountries).filtered.map(({iso2}) => iso2)
          })
          .catch(err => {
            if (err.response?.status === 401) {
              this.openSignInModal()
            }
          })
    },
    getProfile() {
      return this.$http
          .get( 'user/profile')
          .then((res) => {
            if (res.status == 200) {
              this.email = res.data.email
              this.name = res.data.name
              this.surname = res.data.surname
              this.phone = res.data.phone
              this.phoneCountryCode = res.data.phone_country_code
              this.address = res.data.address
              this.postCode = res.data.post_code
              this.city = res.data.city
              this.userCountry = res.data.country
              this.joined = res.data.created_at
              this.balance = res.data.balance
              this.referralCode = res.data.referral_code
            }
          })
    },
    setDefaultCountry() {
      if (this.userCountry && this.countryOptions.length) {
        this.country = this.countryOptions.find(
            (item) => item.iso == this.userCountry.iso
        )
      }
    },
    phoneDataUpdate(e) {
      this.phoneFull = e.number || this.phone
    },
    updateProfileData() {
      const profileData = {
        email: this.email,
        name: this.name,
        phone: this.phoneFull,
        surname: this.surname,
        address: this.address,
        city: this.city,
        post_code: this.postCode,
        country_id: this.country ? this.country?.id : null,
      }
      this.$http
          .put( 'user/profile', profileData)
          .then((res) => {
            if (res.data.status == 'OK') {
              this.errors = {}
              this.$toast.success('Profile successfully updated!')
            }
          })
          .catch((res) => {
            if (res.response.status === 401) {
              this.openSignInModal()
            }
            this.errors = res.response.data.errors
            clearTimeout(this.timeoutId)
            this.timeoutId = setTimeout(() => {
              this.errors = {}
            }, 3000)
          })
    },
    updatePassword() {
      const passwordList = {
        cur_password: this.curPass,
        new_password: this.newPass,
        repeat_password: this.repeatPass,
      }
      this.$http
          .post( 'user/change-password', passwordList)
          .then((res) => {
            if (res.data.status == 'OK') {
              this.passUpdateSuccessMessaage = 'Success'
              this.curPass = ''
              this.newPass = ''
              this.repeatPass = ''
              setTimeout(() => {
                this.passUpdateSuccessMessaage = ''
              }, 3000)
            }
          })
          .catch((res) => {
            if (res.response.status === 401) {
              this.openSignInModal()
            }
            this.passUpdateErrorMessaage = res.response.data.message
            setTimeout(() => {
              this.passUpdateErrorMessaage = ''
            }, 3000)
          })
    },
    updateReferralCode() {
      this.$http
          .put( 'user/referral-code', {
            referral_code: this.referralCode,
            confirmed: false,
          })
          .then((res) => {
            if (res.data.status === 'OK') {
              this.handleSuccessfulUpdate(res.data.message)
            } else if (res.data.status === 'WARNING') {
              this.showWarningDisclaimer(res.data)
            }
          })
          .catch(this.handleUpdateError)
    },
    confirmReferralCodeUpdate() {
      this.$http
          .put( 'user/referral-code', {
            referral_code: this.referralCode,
            confirmed: true,
          })
          .then((res) => {
            if (res.data.status === 'OK') {
              this.handleSuccessfulUpdate(res.data.message)
            }
          })
          .catch(this.handleUpdateError)
      this.showDisclaimer = false
    },
    cancelReferralCodeUpdate() {
      this.showDisclaimer = false
    },
    handleSuccessfulUpdate(message) {
      this.$toast.success(message)
    },
    showWarningDisclaimer(data) {
      this.showDisclaimer = true
      this.disclaimerMessage = `${data.message}<br><br>Current discount: ${data.current_discount_percentage}%<br>New discount: ${data.new_discount_percentage}%`
      this.currentDiscount = data.current_discount_percentage
      this.newDiscount = data.new_discount_percentage
    },
    handleUpdateError(error) {
      if (error.response.status === 401) {
        this.openSignInModal()
      }
      this.toast.error(error.response.data.message || 'An error occurred', {
        timeout: 3000,
      })
    },
    goToProfilePage(page) {
      this.$router.push({ path: '/profile/' + page })
      this.activeProfilePage = page
    },
    copyPrompt(text) {
      const el = document.createElement('textarea');
      // Remove HTML tags for plain text copying
      el.value = text.replace(/<[^>]*>/g, '');
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.$toast.success('Prompt copied to clipboard!');
    },
    downloadPrompt(item) {
      const element = document.createElement('a');
      const text = item.prompt.replace(/<[^>]*>/g, '');
      const file = new Blob([text], {type: 'text/plain'});
      element.href = URL.createObjectURL(file);
      element.download = `${item.title.replace(/\s+/g, '_')}_prompt.txt`;
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    }
  },

  computed: {
    ...mapGetters('user', ['isAuth']),
    getDefaultCountryIso() {
      return this.phoneCountryCode || this.countryOptionsIso[0]
    },
  },
})
</script>

<style scoped>
.conversion-info {
  font-size: 12px;
  color: #989ca2;
  margin-top: 4px;
}

.prompt-col {
  width: 60%;
}

.actions-col {
  width: 151px;
  text-align: center;
  vertical-align: middle;
}

.prompt-text {
  font-size: 14px;
  line-height: 1.6;
  color: #334155;
  text-align: left;
}

.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 6;
  line-clamp: 6;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}

.prompt-actions-cell {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
}

.action-btn-small {
  width: 100%;
  max-width: 120px;
  padding: 6px 12px;
  border-radius: 20px;
  background: #383645;
  color: #fff;
  border: none;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  font-family: "Lexend Exa", sans-serif;
  text-transform: uppercase;
}

.action-btn-small:hover {
  opacity: 0.8;
  transform: translateY(-1px);
}

.action-btn-small:active {
  transform: translateY(0);
}
</style>
